import React from 'react'

export const CheckLogoTheme = ({ width = 35, height = 34, style = { padding: '5px' } }) => {
  return (
    <>
      <img src="/logo.png" width={width} height={height} style={style} />
    </>
  )
}
